import React from 'react';
import './terms.css';

function Terms() {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <h1>Điều khoản sử dụng</h1>
        <p className="terms-updated">Cập nhật lần cuối: 01/10/2025</p>
      </div>

      <div className="terms-content">
        <section className="terms-section">
          <h2>1. Giới thiệu</h2>
          <p>
            Chào mừng bạn đến với GiveawayHub. Bằng việc truy cập và sử dụng dịch vụ của chúng tôi, 
            bạn đồng ý tuân thủ và chịu ràng buộc bởi các điều khoản và điều kiện này.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Điều kiện sử dụng</h2>
          <ul>
            <li>Bạn phải từ đủ 18 tuổi trở lên để sử dụng dịch vụ của chúng tôi</li>
            <li>Bạn phải cung cấp thông tin chính xác và cập nhật khi đăng ký tài khoản</li>
            <li>Bạn chịu trách nhiệm bảo mật thông tin tài khoản của mình</li>
            <li>Không được sử dụng dịch vụ cho các mục đích bất hợp pháp</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>3. Quy định về tổ chức Giveaway</h2>
          <ul>
            <li>Phải tuân thủ pháp luật Việt Nam và quốc tế về tổ chức sự kiện</li>
            <li>Không được tổ chức các Giveaway liên quan đến cờ bạc, ma túy, vũ khí</li>
            <li>Phải công khai và minh bạch về điều kiện tham gia và cách thức chọn người thắng</li>
            <li>Phải thực hiện đúng cam kết về giải thưởng đã công bố</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>4. Quyền và trách nhiệm</h2>
          <h3>4.1. Quyền của người dùng</h3>
          <ul>
            <li>Được tạo và tham gia các phòng Giveaway</li>
            <li>Được nhận hỗ trợ kỹ thuật khi cần thiết</li>
            <li>Được bảo vệ thông tin cá nhân</li>
          </ul>

          <h3>4.2. Trách nhiệm của người dùng</h3>
          <ul>
            <li>Không spam hoặc quấy rối người khác</li>
            <li>Không chia sẻ thông tin đăng nhập với người khác</li>
            <li>Báo cáo các hành vi vi phạm điều khoản</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. Giới hạn trách nhiệm</h2>
          <p>
            GiveawayHub không chịu trách nhiệm về:
          </p>
          <ul>
            <li>Các tranh chấp giữa người tổ chức và người tham gia</li>
            <li>Thiệt hại phát sinh do việc sử dụng dịch vụ</li>
            <li>Sự gián đoạn dịch vụ do yếu tố khách quan</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>6. Thay đổi điều khoản</h2>
          <p>
            Chúng tôi có quyền thay đổi điều khoản này vào bất kỳ lúc nào. 
            Các thay đổi sẽ có hiệu lực ngay khi được đăng tải trên website.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Terms; 